import React from 'react';
import { useTranslation } from 'next-i18next';
import get from 'lodash/get';
import { c as classnames } from './index-2586sEvh.js';

const Textarea = ({ register, errors, name, label = '', disabled = false, placeholder = '', variant = 'stacked', }) => {
    const { t } = useTranslation('');
    const errorText = get(errors, `${name}.message`, '');
    const isError = Boolean(errorText);
    return (React.createElement("div", { className: `form-control text-area-wrapper ${variant}-text-area` },
        label && (React.createElement("label", { htmlFor: name, className: "label" }, label)),
        React.createElement("div", { className: "form-control-wrapper" },
            React.createElement("textarea", { ...register(name), id: name, disabled: disabled, placeholder: placeholder, className: classnames('input', { error: isError }) }),
            isError && (React.createElement("div", { className: "error", role: "alert" }, t(errorText))))));
};

export { Textarea as T };
//# sourceMappingURL=Textarea-CrVLRrCI.js.map
